export default function useGetCategoryId(item) {
  if (item.categories && item.categories[0] && item.categories[0].id) {
    return item.categories[0].id;
  } else {
    return null;
  }
}
